export class Direccion {
    departamento: { 
        codigo: string, 
        nombre: string 
    };
    ciudad: { 
        codigo: string, 
        nombre: string 
    };
    direccionPrincipal: string;

    static instace() {
        return new this();
    }
};